import { render, staticRenderFns } from "./Canhoto.vue?vue&type=template&id=5ed57360"
import script from "./Canhoto.vue?vue&type=script&lang=js"
export * from "./Canhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports